function openOnglet(ongletActive, section, index) {
	var sectionElement = document.querySelector(section);

	var ongletAll = sectionElement.querySelectorAll(".mm-oi-onglet-title");
	ongletAll.forEach(function (onglet) {
		if (onglet === ongletActive) {
			onglet.classList.add("mm-active");
		} else {
			onglet.classList.remove("mm-active");
		}
	});

	var contentAll = sectionElement.querySelectorAll(".mm-oi-content");
	var contentActive = `mm-oi-content-${index}`;

	contentAll.forEach(function (content) {
		if (content.classList.contains(contentActive)) {
			content.classList.remove("mm-content-none");
		} else {
			content.classList.add("mm-content-none");
		}
	});
  adjustBackgroundSize(sectionElement);
}

function adjustBackgroundSize(section) {
    let ongletActive = section.querySelector(".mm-oi-onglet-title.mm-active");
    let bgActive = document.querySelector(".mm-oi-onglet-title-bg");

    if (ongletActive && bgActive) {
      let rect = ongletActive.getBoundingClientRect();
      let containerRect = ongletActive.parentElement.getBoundingClientRect();

      bgActive.style.width = rect.width + "px";
      bgActive.style.height = rect.height + "px";
      bgActive.style.top = rect.top - containerRect.top - 1 + "px";
      bgActive.style.left = rect.left - containerRect.left - 1 + "px";
    }
}

if (window.innerWidth > 768) {
  document.addEventListener('DOMContentLoaded', function() {
    const sectionOnglets = document.querySelectorAll(".mm-section-onglets-image");
    sectionOnglets.forEach(section => {
      adjustBackgroundSize(section)
    })
  });
}
